
import { SaleLayoutDetailImage } from "@/utils/sale-layouts/detail-image";
import Vue from "vue";
export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>SaleLayoutDetailImage,
			required: true
		}
	}
});
